export default {

    data:()=>({
        active: false,
        btnLoading: false,
        server_errors: {
            name: '',
            tel: '',
            email: '',
            prefix: '',
            villageId: '',
        },

        parts: [],
        provinces: [],
        districts: [],
        villages: [],

        selectedPart: {},
        selectedProvince: {},
        selectedDistrict: {},

        filterProvinces: [],
        filterDistricts: [],
        filterVillages: [],

        checkVillage: true,

        translateInloas:{
            north: 'ພາກເໜືອ',
            center: 'ພາກກາງ',
            central: 'ພາກກາງ',
            south: 'ພາກໃຕ້',
            northeastern: 'ພາກຕາເວັນອອກສຽງເໜືອ',
            southwest: 'ຕາເວັນຕົກສຽງໃຕ້',
            southern: 'ພາກໃຕ້-1'
        }
    }),

    methods:{
        ValidateForm(){
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.EditItem();
                }
            });
        }, // Validate-Form

        EditItem(){
            this.btnLoading = true;
            this.listVehicleDepartment.villageId = this.selectedVillage.village_id;
            this.$axios.put('edit-vehicle-departments', this.listVehicleDepartment).then(res=>{
                if(res.data.success == true){
                    setTimeout(() => {
                        this.btnLoading = false;
                        this.$emit('close');
                        this.$emit('success');
                        this.$notification.OpenNotification_EditItem_OnSuccess('top-right', 'dark', 3000);
                    }, 300);
                }
            }).catch(error=>{
                this.btnLoading = false;
                if(error.response.status == 422){
                    var obj = error.response.data.errors;       // ໃຊ້ການລູບຂໍ້ມູນເພາະວ່າຂໍ້ມູນ errors ທີ່ສົ່ງມາຈາກ Server ນັ້ນເປັນ Array Object
                    for (let [key, value] of Object.entries(obj)) {
                        this.server_errors[key] = value[0];
                    }
                }
            });
        }, // EditItems

        FetchData(){
            this.$axios.get('list-branch-address').then(res=>{
                const items = res.data.data;

                this.parts = items.parts;
                this.provinces = items.provinces;
                this.districts = items.districts;
                this.villages = items.villages;

                this.selectedPart = this.listVehicleDepartment;
                this.selectedType = this.listVehicleDepartment;

                this.filterProvinces = items.provinces;
                this.filterDistricts = items.districts;
                this.filterVillages = items.villages;

                this.FilterProvinces(this.selectedPart.partId);
                this.selectedProvince = this.listVehicleDepartment;
                this.FilterDistricts(this.selectedProvince.proId);
                this.selectedDistrict = this.listVehicleDepartment;
                this.FilterVillages(this.selectedDistrict.distId);
                this.selectedVillage = this.listVehicleDepartment;
            }).catch(()=>{});
        }, // FetchData-To-Server

        FilterProvinces(partId){
            const result_checking = this.filterProvinces.filter(item=>{
                if(item.part_id == partId){
                    return item;
                }
            });
            this.provinces = result_checking;
            this.selectedProvince = {...result_checking[0]};

            this.FilterDistricts(this.selectedProvince.proId);
        }, // Filter-Provinces

        FilterDistricts(proId){
            const result_checking = this.filterDistricts.filter(item=>{
                if(item.province_id == proId){
                    return item;
                }
            });
            this.districts = result_checking;
            this.selectedDistrict = {...result_checking[0]};
            this.FilterVillages(this.selectedDistrict.distId);
        }, // Filter-Distircts

        FilterVillages(distId){
            const result_checking = this.filterVillages.filter(item=>{
                if(item.district_id == distId){
                    return item;
                }
            });
            this.villages = result_checking;
            this.selectedVillage = {...result_checking[0]};
        }, // Filter-Villages
    },
    watch: {
        'selectedVillage.village_id':function(){
            this.server_errors.villageId = '';
        },
        'listVehicleDepartment.prefix':function(){
            this.server_errors.prefix = '';
        },
        'listVehicleDepartment.name':function(){
            this.server_errors.name = '';
        },
        'listVehicleDepartment.tel':function(){
            this.server_errors.tel = '';
        },
        'listVehicleDepartment.email':function(){
            this.server_errors.email = '';
        }
    },
}
